<template>
  <div class="parent-A">
    <img class="child-B" :src="imageUrl" alt="旋转图片" />
    <img class="child-C" :src="imageUrl2" alt="旋转图片" />
    <div class="circle"><img :src="liu" alt="" /></div>
    <div class="small"></div>
    <div class="big"></div>

    <div class="tag tag1" :class="{ active: active }"></div>
    <div class="tag tag2" :class="{ active: active }"></div>
    <div class="tag tag3" :class="{ active: active }"></div>
    <div class="tag tag4" :class="{ active: active }"></div>
    <div class="tag tag5" :class="{ active: active }"></div>
    <div class="tag tag6" :class="{ active: active }"></div>
  </div>
</template>

<script>
import imageUrl from '@/assets/home/circle01.png'
import imageUrl2 from '@/assets/home/circle02.png'
import liu from '@/assets/home/6.png'
export default {
  name: 'CircleCom',
  data() {
    return {
      imageUrl,
      imageUrl2,
      liu,
      observer: null,
      isInViewport: false,
      active: false,
    }
  },
  methods: {
    observeElement() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isInViewport = true
            this.handleElementEnter(entry.target)
          } else {
            this.isInViewport = false
            this.handleElementLeave(entry.target)
          }
        })
      }, options)

      const elements = document.querySelectorAll('.parent-A')
      elements.forEach((el) => this.observer.observe(el))
    },
    handleElementEnter(element) {
      console.log('✅ parent-A 进入视窗')
      this.active = true
      element.style.opacity = '1'
      element.style.transform = 'translateY(0)'
    },
    handleElementLeave() {
      this.active = false
      console.log('❌ parent-A 离开视窗')
      // 可选：元素离开时的处理
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.observeElement()
    })
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  },
}
</script>

<style lang="scss" scoped>
.parent-A {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 1px;
  height: 1px;
  border: 1px solid red;
}

.child-B {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 215px;
  height: 215px;
  transform-origin: 100% 100%;
  animation: rotateAroundP 8s linear infinite;
}

.child-C {
  position: absolute;
  left: 0;
  top: 0;
  width: 215px;
  height: 215px;
  transform-origin: 0% 0%;
  animation: rotateAroundP 8s linear infinite;
}
.circle {
  position: absolute;
  left: 50%;
  top: 50%;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  width: 268px;
  height: 268px;
  background: linear-gradient(21.34deg, #1ca196 -6.08%, #04c859 104.33%);
  display: flex;
  justify-content: center;
  align-items: center;
}
.small {
  position: absolute;
  left: 50%;
  top: 50%;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  width: 365px;
  height: 365px;
  angle: 0 deg;
  opacity: 1;
  border: 1px solid #1ca19680;
}
.big {
  position: absolute;
  left: 50%;
  top: 50%;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  width: 540px;
  height: 540px;
  angle: 0 deg;
  opacity: 1;
  border: 1px solid #1ca19640;
}

@keyframes rotateAroundP {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.tag {
  position: absolute;
  width: 317px;
  height: 108px;
}
.tag1 {
  //right: 116px;
  //bottom: 140px;
  right: 1500px;
  bottom: 340px;
  background: url('@/assets/home/circleIcon01.png') no-repeat center center;
  &.active {
    animation: positionFly1 1s linear 1 forwards;
  }
}
.tag2 {
  //left: 116px;
  //bottom: 140px;
  left: 1500px;
  bottom: 340px;
  background: url('@/assets/home/circleIcon02.png') no-repeat center center;
  &.active {
    animation: positionFly2 1s linear 1 forwards;
  }
}
.tag3 {
  //right: 195px;
  right: 1500px;
  bottom: 0;
  background: url('@/assets/home/circleIcon03.png') no-repeat center center;
  &.active {
    animation: positionFly3 1s linear 1 forwards;
  }
}
.tag4 {
  //left: 195px;
  left: 1500px;
  bottom: 0;
  background: url('@/assets/home/circleIcon04.png') no-repeat center center;
  &.active {
    animation: positionFly4 1s linear 1 forwards;
  }
}
.tag5 {
  //right: 116px;
  //top: 88px;
  right: 1500px;
  top: -288px;
  background: url('@/assets/home/circleIcon05.png') no-repeat center center;
  &.active {
    animation: positionFly5 1s linear 1 forwards;
  }
}
.tag6 {
  //left: 116px;
  //top: 88px;
  left: 1500px;
  top: -288px;
  background: url('@/assets/home/circleIcon06.png') no-repeat center center;
  &.active {
    animation: positionFly6 1s linear 1 forwards;
  }
}

@keyframes positionFly1 {
  0% {
    right: 1000px;
    bottom: 340px;
  }
  100% {
    right: 116px;
    bottom: 140px;
  }
}

@keyframes positionFly2 {
  0% {
    left: 1000px;
    bottom: 340px;
  }
  100% {
    left: 116px;
    bottom: 140px;
  }
}

@keyframes positionFly3 {
  0% {
    right: 1000px;
    bottom: 0;
  }
  100% {
    right: 195px;
    bottom: 0;
  }
}

@keyframes positionFly4 {
  0% {
    left: 1000px;
    bottom: 0;
  }
  100% {
    left: 195px;
    bottom: 0;
  }
}

@keyframes positionFly5 {
  0% {
    right: 1000px;
    top: -288px;
  }
  100% {
    right: 116px;
    top: 88px;
  }
}

@keyframes positionFly6 {
  0% {
    left: 1000px;
    top: -288px;
  }
  100% {
    left: 116px;
    top: 88px;
  }
}
</style>
